module.exports = __webpack_public_path__ + "static/mobile-689b9e500d89e7c31d66058b2b9707a3.png";